@if (items().length > 0) {
  @if (printVersion()) {
    @for (collateralItemEntity of items(); track collateralItemEntity) {
      <nk-collateral-item class="d-inline-block mb-1 br-1" [item]="collateralItemEntity"></nk-collateral-item>
    }
  } @else {
    <nk-collateral-item [item]="items()[0]"></nk-collateral-item>
    @if (items().length > 1) {
      <div [popover]="shipPopover" [outsideClick]="true" class="text-info underline pointer clickable mt-1">
        {{ 'company_collateral.more_items_tooltip' | translate: { numberOfItems: items().length - 1 } }}
      </div>
    }
  }
} @else {
  -
}

<ng-template #shipPopover>
  <div class="text-left">
    <p class="mb-2">{{ 'company_collateral.more_items_title' | translate }}</p>
    @for (collateralItemEntity of items(); track collateralItemEntity) {
      <div class="mb-1">
        <nk-collateral-item [item]="collateralItemEntity"></nk-collateral-item>
      </div>
    }
  </div>
</ng-template>
